import { Check, X, Minus } from 'lucide-react';

export const ProductComparison = ({ 
  title = "Product Comparison",
  products = [],
  features = []
}) => {
  const renderFeatureValue = (value) => {
    if (value === true) return <Check className="w-5 h-5 text-[#3A4D39]" />;
    if (value === false) return <X className="w-5 h-5 text-[#C88D74]" />;
    if (value === null) return <Minus className="w-5 h-5 text-[#6B7280]" />;
    return <span className="text-sm text-[#374151]">{value}</span>;
  };

  return (
    <div data-testid="product-comparison" className="overflow-x-auto">
      <table className="w-full min-w-[600px] border-collapse">
        {/* Header with Product Names */}
        <thead>
          <tr>
            <th className="p-4 text-left bg-[#F5F5F0] border-b border-[#E5E5E5] w-1/4">
              <span className="text-xs tracking-widest uppercase font-medium text-[#6B7280]">
                {title}
              </span>
            </th>
            {products.map((product, index) => (
              <th 
                key={index} 
                className="p-4 text-center bg-[#F5F5F0] border-b border-[#E5E5E5]"
              >
                <div className="space-y-2">
                  {/* Product Image Placeholder */}
                  <div className="w-20 h-20 mx-auto bg-[#F2EBE3] flex items-center justify-center">
                    <span className="font-accent italic text-xs text-[#6B7280]">Image</span>
                  </div>
                  <h4 className="font-heading text-lg font-semibold text-[#1C1C1C]">
                    {product.name}
                  </h4>
                  <span className="inline-block px-2 py-0.5 bg-[#F2EBE3] text-[#3A4D39] text-xs font-medium">
                    {product.bestFor}
                  </span>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        
        {/* Feature Rows */}
        <tbody>
          {features.map((feature, featureIndex) => (
            <tr 
              key={featureIndex}
              className={featureIndex % 2 === 0 ? 'bg-white' : 'bg-[#FDFCF8]'}
            >
              <td className="p-4 border-b border-[#E5E5E5]">
                <span className="font-medium text-[#1C1C1C]">{feature.name}</span>
                {feature.description && (
                  <p className="text-xs text-[#6B7280] mt-1">{feature.description}</p>
                )}
              </td>
              {products.map((product, productIndex) => (
                <td 
                  key={productIndex} 
                  className="p-4 text-center border-b border-[#E5E5E5]"
                >
                  {renderFeatureValue(product.features[feature.key])}
                </td>
              ))}
            </tr>
          ))}
          
          {/* CTA Row */}
          <tr className="bg-[#F5F5F0]">
            <td className="p-4">
              <span className="text-sm text-[#6B7280]">View Product</span>
            </td>
            {products.map((product, index) => (
              <td key={index} className="p-4 text-center">
                {product.affiliateLink && product.affiliateLink !== "#" ? (
                  <a
                    href={product.affiliateLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`compare-cta-${index}`}
                    className="inline-flex items-center justify-center px-4 py-2 bg-[#3A4D39] text-white text-xs font-medium tracking-wide uppercase transition-all duration-300 hover:bg-[#2A3D29]"
                  >
                    View Product
                  </a>
                ) : (
                  <span className="text-xs text-[#6B7280] italic font-accent">
                    Coming soon
                  </span>
                )}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
      <p className="mt-4 text-xs text-[#6B7280] italic font-accent text-center">
        Product examples shown are for category illustration purposes. Specific recommendations will be added soon.
      </p>
    </div>
  );
};

export default ProductComparison;
